import React from 'react';
import AboutFull from '../components/AboutFull';

const AboutPage = () => {
  return (
    <>
      <AboutFull />
    </>
  );
};

export default AboutPage;
